export const SET_LANG_UNIVERSAL = 'SET_LANG_UNIVERSAL';
